<template>
  <v-row class="ma-0" justify="center">
    <!-- loading -->
    <v-progress-circular v-if="loading" :size="15" color="main" indeterminate />

    <template v-else>
      <!-- edit request dialog -->
      <v-menu v-model="actionMenu" :close-on-content-click="false" offset-x left>
        <!-- activator icon -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-on="on" v-bind="attrs" small class="mr-2">mdi-square-edit-outline</v-icon>
        </template>

        <v-card>
          <!-- title -->
          <v-card-title class="d-flex justify-center">
            <h4 class="main--text">{{ translations[item.status === 'PENDING' ? 'handleRequest' : 'changeRequest'] }}</h4>
          </v-card-title>

          <v-card-text>
            <!-- status buttons -->
            <div v-if="!showTextArea" class="d-flex justify-center">
              <v-btn v-if="item.status !== 'REJECTED'" @click="showTextArea = true, type = 'REJECTED'" small color="error" class="mr-2" text depressed>{{ translations.deny }}</v-btn>
              <v-btn v-if="item.status !== 'APPROVED'" @click="showTextArea = true, type = 'APPROVED'" small color="main" class="white--text" depressed>{{ translations.approve }}</v-btn>
            </div>

            <!-- note input -->
            <div v-else>
              <div class="mb-2">
                {{ translations.optionalNoteForRequest }}:
              </div>
              <v-textarea v-model="note" filled flat dense hide-details height="100"></v-textarea>

              <div class="mt-4 d-flex justify-space-between">
                <v-btn @click="showTextArea = false, type = null, note = item.note" small text class="white--text" color="main">{{ translations.cancel }}</v-btn>
                <v-btn @click="changeActivityRequest(type)" small class="white--text" color="main">{{ translations.confirm }}</v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-menu>


      <!-- delete -->
      <v-icon v-if="!item.loading"
              @click="deleteActivityRequest"
              small color="error lighten-1" class="cursor-pointer">
        mdi-delete-outline
      </v-icon>
    </template>
  </v-row>
</template>


<script>
import { translations } from '@/utils/common'
import ActivityRequestService from '@/service/activityRequest/ActivityRequestService'

export default {
  name: 'ActivityRequestEdit',

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      translations: translations,

      actionMenu: false,
      showTextArea: false,
      type: null,
      loading: false,
      note: null
    }
  },

  methods: {
    async changeActivityRequest(action) {
      this.loading = true
      await ActivityRequestService.change({
          activityRequestId: this.item.id,
          employeeId: this.item.employee.id,
          status: action,
          note: this.note && this.note.length > 0 ? this.note : null
        })
        .then(() => {
          this.$root.vtoast.show({ message: translations.updateSuccess })
          this.$emit('updated')
        })
        .finally(() => {
          this.actionMenu = false
          this.showTextArea = false
          this.type = null
          this.loading = false
        })
    },

    async deleteActivityRequest() {
      this.loading = true
      await ActivityRequestService.delete({
          activityRequestId: this.item.id,
          employeeId: this.item.employee.id
        })
        .then(() => {
          this.$root.vtoast.show({ message: translations.deletedSuccess })
          this.$emit('updated')
        })
        .finally(() => {
          this.loading = false
        })
    }
  },

  watch: {
    item: {
      handler(val) {
        this.note = val.note
      },
      deep: true
    }
  }
}
</script>


<style>
.actions {
  display: flex
}

.status-chip {
  min-width: 80px;
  justify-content: center;
}
</style>
